// extracted by mini-css-extract-plugin
export default {"icon":"FavourIcon_icon__a-vXW","icon__fill":"FavourIcon_icon__fill__5vmwi","icon_active":"FavourIcon_icon_active__jAIWU"};